var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVmLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 255,
    height: 85,
    viewBox: "0 0 255 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.069 37.0596C138.981 38.8213 135.803 40.629 131.821 41.2047C131.09 41.3275 130.335 41.3947 129.537 41.3947V43.3694V46.3765C134.802 46.3765 138.668 44.1734 142.404 42.0414C146.392 39.7693 150.156 37.6219 155.946 37.6219V34.6359V32.6401C155.742 32.6401 155.542 32.6421 155.341 32.6478C154.136 32.6747 153.001 32.7821 151.925 32.9529C148.086 33.6304 145.142 35.3076 142.069 37.0596Z",
    fill: "#00E8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.537 51.9491V56.9328C134.802 56.9328 138.668 54.7298 142.404 52.5978C146.39 50.3256 150.156 48.1783 155.946 48.1783V43.1946C148.951 43.1946 144.271 45.8639 140.143 48.2166C136.631 50.2201 133.599 51.9491 129.537 51.9491Z",
    fill: "#00E8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.143 58.7752C136.631 60.7767 133.599 62.5058 129.535 62.5058V66.2536V67.4875C129.14 67.5067 128.742 67.5182 128.343 67.5182C114.874 67.5182 103.916 56.2958 103.916 42.5019C103.916 28.708 114.874 17.4856 128.343 17.4856C136.852 17.4856 144.357 21.9646 148.732 28.7406C150.295 28.2782 151.989 27.9308 153.852 27.7658C148.817 18.6581 139.271 12.5 128.345 12.5C112.193 12.5 99.0518 25.9581 99.0518 42.5C99.0518 59.0419 112.193 72.5 128.345 72.5C128.744 72.5 129.141 72.4904 129.537 72.4731V67.5163V67.4894C130.118 67.4894 130.678 67.4607 131.227 67.4108C134.48 67.0116 137.139 65.5052 140.146 63.7953C143.531 61.8706 147.284 59.7385 152.377 59.0304C153.484 58.8424 154.667 58.7368 155.948 58.7368V55.7067V53.7531C148.953 53.7512 144.273 56.4206 140.143 58.7752Z",
    fill: "#00E8A8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56.8966,
    height: 60,
    fill: "white",
    transform: "translate(99.0518 12.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVmLogo);
export default __webpack_public_path__ + "static/media/vmLogo.2eb80d5984b28d71fe74e32d55ea4390.svg";
export { ForwardRef as ReactComponent };